import { createContext } from 'react';
import { IMenuContextState } from './types';

export const MenuContext = createContext<IMenuContextState | undefined>(undefined);
